import React from 'react'
import PropTypes from 'prop-types'
import { Box, Image } from '@chatterbug/aaron'
import Flag from 'src/components/Flag/Flag'
import Pressable from 'src/ui/Pressable/Pressable'

import fallbackIcon from './assets/fallback.svg'

const UpcomingLessonIcon = ({
  iconUrl,
  lessonLanguageCode,
  unitUrl,
  altText,
  showFlag,
}) => {
  return (
    <Pressable linkUrl={unitUrl} altText={altText}>
      <Box position="relative">
        <Image
          bg="white100"
          src={iconUrl || fallbackIcon}
          borderRadius="full"
          boxShadow="inset 0 0 0 1px white, 0 0 0 2px white"
          height="72px"
          width="72px"
          mb="1x"
          alt=""
        />
        {showFlag && (
          <Box position="absolute" top="-5%" right="0">
            <Flag size="s" countryCode={lessonLanguageCode} />
          </Box>
        )}
      </Box>
    </Pressable>
  )
}

UpcomingLessonIcon.propTypes = {
  iconUrl: PropTypes.string,
  lessonLanguageCode: PropTypes.string.isRequired,
  unitUrl: PropTypes.string,
  altText: PropTypes.string,
  showFlag: PropTypes.bool,
}

export default UpcomingLessonIcon
